import image1 from '../assets/blurb1ConfigImage1.jpg';


export const blurb1Config = {
      heading: "Bringing Affordable Entertainment to Las Vegas",
      paragraph: "“Slaughter Comedy is out to prove Las Vegas has talented people off the strip, one show at a time”",
      blurb1Image: image1,
    };